module.exports = __webpack_public_path__ + "assets/img/6_535.facb00bd.jpg";